import styled from 'styled-components';

export const CellContainerStyled = styled.div`
  //The absolute positioning and 100% width is required, if not hovering over other regions of the cell will not show the pick list button
  padding-left: '20px';
  position: absolute;
  width: 100%;
  top: 0px;
  left: 0px;
`;
